import { ProductDTO } from '@/api/dto/ProductDTO';
import { CrudEndpoint } from '@/api/common/CrudEndpoint';

export class ProductCRUD extends CrudEndpoint<ProductDTO> {
  constructor() {
    super('product');
  }
}
